import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Glasses } from 'lucide-react';
import { PERMISSIONS } from '@optiflow/types';
import { usePermissions } from '@/hooks/usePermissions';

/**
 * The way into frame recommendations from a customer's profile.
 *
 * Rendered only for someone who may ask for recommendations; the route and the API refuse everyone else anyway. It carries the customer in the address, so nobody picks the same customer twice.
 */
export function RecommendFramesLink({ customerId }: { customerId: string }) {
  const { t } = useTranslation();
  const { can } = usePermissions();

  if (!can(PERMISSIONS.FRAME_RECOMMEND)) return null;

  return (
    <Link
      to={`/customers/${customerId}/frame-recommendations`}
      className="text-ink border-line hover:bg-canvas inline-flex h-10 items-center justify-center gap-2 rounded-lg border bg-white px-4 text-sm font-medium transition-colors"
    >
      <Glasses className="size-4" aria-hidden />
      {t('frameRecommendations.action')}
    </Link>
  );
}
